import React, { Component } from "react";

import { Link } from "react-router-dom";
import styles from "./styles";
import { withStyles } from "@material-ui/styles";

import styled from "styled-components";

import { Fonts } from "Themes";

const NavText = styled.div`
  cursor: pointer;
  padding: 10px;
  background-color: ${props => (props.selected ? "white" : "lightgray")};
  font-family: ${Fonts.primaryFontFamily};
  &:hover {
    text-decoration: underline;
  },
`;

class NavigationSidepanel extends Component {
  state = {
    selectedItem: 0,
    dropdown: false
  };

  _onFilterClick = (filter, key) => {
    this.setState({ selectedItem: key });
    this.props.filterClick(filter);
  };

  render() {
    const { titles, classes, links, rootPath } = this.props;
    const { selectedItem } = this.state;
    return (
      <div className={classes.navigationSidepanel}>
        {titles.map((title, key) => {
          return (
            <Link
              to={`${rootPath}${links[key]}`}
              className={classes.link}
              onClick={() => this.setState({ selectedItem: key })}
              key={key}
            >
              <NavText selected={selectedItem === key}>{title}</NavText>
            </Link>
          );
        })}
      </div>
    );
  }
}

export default withStyles(styles)(NavigationSidepanel);
